import { render, staticRenderFns } from "./GerenciarIpgs.vue?vue&type=template&id=eddc71e2&scoped=true"
import script from "./script.js?vue&type=script&lang=js&external"
export * from "./script.js?vue&type=script&lang=js&external"
import style0 from "./GerenciarIpgs.vue?vue&type=style&index=0&id=eddc71e2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eddc71e2",
  null
  
)

export default component.exports